var _rect, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNew(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 14,
    viewBox: "0 0 30 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 14,
    rx: 4,
    fill: "url(#paint0_linear_1795_2570)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8881 4H17.8207L18.8746 8.21561H18.9049L20.0119 4H20.8762L21.9832 8.21561H22.0135L23.0674 4H24L22.4381 9.41357H21.5586L20.4592 5.23587H20.4289L19.3295 9.41357H18.4424L16.8881 4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5237 4H16.4133V4.70513H13.3501V6.28219H16.2313V6.98732H13.3501V8.70844H16.5422V9.41357H12.5237V4Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 4H7.83402L10.6015 8.02606H10.6318V4H11.4582V9.41357H10.6545L7.85677 5.34202H7.82644V9.41357H7V4Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1795_2570",
    x1: 8,
    y1: -2.5,
    x2: 10,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD64FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#677BF8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.0a820d0519a4602591e6ead8a28e881d.svg";
export { ForwardRef as ReactComponent };